import {NgModule} from '@angular/core';
import {Routes} from '@angular/router';

@NgModule({
	imports: [
		// example: ...(window['baseApplication'] === 'base-application-id' ? [BaseAppModule] : [])
	]
})
export class DynamicAppModule {

	public static getRoutes(): Routes {
		// example: if (window['baseApplication'] === 'base-application-id') return BaseAppModule.getRoutes();
		return [];
	}
}
